import { FORM_TEXT } from "./textConstants";

// export const US_STATES = [
//   { id: '', value: '' },
//   { id: 'AL', value: 'Alabama' },
//   { id: 'AK', value: 'Alaska' },
//   { id: 'AZ', value: 'Arizona' },
//   { id: 'AR', value: 'Arkansas' },
//   { id: 'CA', value: 'California' },
//   { id: 'CO', value: 'Colorado' },
//   { id: 'CT', value: 'Connecticut' },
//   { id: 'DE', value: 'Delaware' },
//   { id: 'FL', value: 'Florida' },
//   { id: 'GA', value: 'Georgia' },
//   { id: 'HI', value: 'Hawaii' },
//   { id: 'ID', value: 'Idaho' },
//   { id: 'IL', value: 'Illinois' },
//   { id: 'IN', value: 'Indiana' },
//   { id: 'IA', value: 'Iowa' },
//   { id: 'KS', value: 'Kansas' },
//   { id: 'KY', value: 'Kentucky' },
//   { id: 'LA', value: 'Louisiana' },
//   { id: 'ME', value: 'Maine' },
//   { id: 'MD', value: 'Maryland' },
//   { id: 'MA', value: 'Massachusetts' },
//   { id: 'MI', value: 'Michigan' },
//   { id: 'MN', value: 'Minnesota' },
//   { id: 'MS', value: 'Mississippi' },
//   { id: 'MO', value: 'Missouri' },
//   { id: 'MT', value: 'Montana' },
//   { id: 'NE', value: 'Nebraska' },
//   { id: 'NV', value: 'Nevada' },
//   { id: 'NH', value: 'New Hampshire' },
//   { id: 'NJ', value: 'New Jersey' },
//   { id: 'NM', value: 'New Mexico' },
//   { id: 'NY', value: 'New York' },
//   { id: 'NC', value: 'North Carolina' },
//   { id: 'ND', value: 'North Dakota' },
//   { id: 'OH', value: 'Ohio' },
//   { id: 'OK', value: 'Oklahoma' },
//   { id: 'OR', value: 'Oregon' },
//   { id: 'PA', value: 'Pennsylvania' },
//   { id: 'RI', value: 'Rhode Island' },
//   { id: 'SC', value: 'South Carolina' },
//   { id: 'SD', value: 'South Dakota' },
//   { id: 'TN', value: 'Tennessee' },
//   { id: 'TX', value: 'Texas' },
//   { id: 'UT', value: 'Utah' },
//   { id: 'VT', value: 'Vermont' },
//   { id: 'VA', value: 'Virginia' },
//   { id: 'WA', value: 'Washington' },
//   { id: 'WV', value: 'West Virginia' },
//   { id: 'WI', value: 'Wisconsin' },
//   { id: 'WY', value: 'Wyoming' }
// ];

export const AUTO_SEARCH_TYPE_OPTIONS = [

  { id: 'local', value: 'Local Search' },
  { id: 'name', value: 'Name Search' },

];


export const PROPERTY_SEARCH_TYPE_OPTIONS = [
  { id: 'local', value: 'Local Search' },
  { id: 'name', value: 'Name Search' },
];

export const VENDOR_TYPE_OPTIONS = [
  { id: '', value: '' },
  { id: 'legal', value: 'Legal' },
  { id: 'WC', value: 'WC' },
];

export const PROVIDER_CLAIM_VENDOR_TYPE_OPTIONS = [
  { id: '602', value: 'BOARD UP Services' },
  { id: '613', value: 'Dry Cleaning' },
  { id: '610', value: 'Emergency Svcs/General' },
  { id: '687', value: 'Mitigation Dispatch' }
];



export const PROPERTY_VENDOR_TYPE_OPTIONS = [
  { id: '', value: '' },
  { id: 'EXPERT_APPRAISERS', value: 'Experts- Appraisers(Forensic Specialist)' },
  { id: 'EXPERT_CAUSE_ORIGIN', value: 'Experts- Cause/Origin' },
  { id: 'EXPERT_ENGINEER', value: 'Experts- Engineer' },
  { id: 'EXPERT_OTHER_TECH', value: 'Experts- Other Technical' },
  { id: 'GREEN_EXPERTS', value: 'Green Experts' },
  { id: 'PROPERTY_ADJUSTERS', value: 'Property - Adjusters/Evaluations' },
  { id: 'PROPERTY_ALL_DAMAGES', value: 'Property - All Damages' },
  { id: 'PROPERTY_CLEANUP', value: 'Property- Cleanup/Replacement' },
  { id: 'PROPERTY_REPAIRS', value: 'Property- Repairs' },
  { id: 'PROPERTY_SPECIALIST', value: 'Property- Specialist' }
];

// Mapping of vendor types to their available specialities for property vendors
// Keys are numeric codes from API (PROPERTYVENDORTYPE category)
export const VENDOR_TYPE_SPECIALITY_MAP: Record<string, Array<{ id: string; value: string }>> = {
  '101': [ // Experts- Appraisers(Forensic Specialist)
    { id: '', value: '' },
    { id: '709', value: 'Building/Other' },
    { id: '707', value: 'Equipment/Machinery' },
    { id: '684', value: 'Furniture Repair Services' },
    { id: '708', value: 'Furniture/Household' },
    { id: '705', value: 'Property Appraiser' },
    { id: '706', value: 'Real Estate/Commercial' }
  ],
  '102': [ // Experts- Cause/Origin
    { id: '', value: '' },
    { id: '700', value: 'Fire Cause and Origin' },
    { id: '703', value: 'Fire Protection' },
    { id: '702', value: 'Video, Computer Analysis' }
  ],
  '103': [ // Experts- Engineer
    { id: '', value: '' },
    { id: '717', value: 'Chemical Engineer' },
    { id: '715', value: 'Civil Engineer' },
    { id: '765', value: 'Cyber Security Forensics' },
    { id: '711', value: 'Electrical Engineer' },
    { id: '710', value: 'Engineers (All)' },
    { id: '712', value: 'Forensic Engineer' },
    { id: '713', value: 'Mechanical Engineer' },
    { id: '716', value: 'Metallurgical Engineer' },
    { id: '714', value: 'Structural/Architect' }
  ],
  '104': [ // Experts- Other Technical
    { id: '', value: '' },
    { id: '732', value: 'Accounting' },
    { id: '762', value: 'Arborists/Tree Evaluations' },
    { id: '730', value: 'Biomedical' },
    { id: '722', value: 'Boiler' },
    { id: '729', value: 'Chemist' },
    { id: '765', value: 'Cyber Security Forensics' },
    { id: '745', value: 'Elevators/Escalators' },
    { id: '725', value: 'Geologist' },
    { id: '736', value: 'Heavy Equipment' },
    { id: '670', value: 'Hotels' },
    { id: '727', value: 'HVAC' },
    { id: '724', value: 'Hygienist' },
    { id: '763', value: 'Lab Services - Asbestos' },
    { id: '721', value: 'Lab Services - Other' },
    { id: '720', value: 'Other Technical Experts (All)' },
    { id: '728', value: 'Other Technical Services' },
    { id: '723', value: 'Property Expert - Other' },
    { id: '726', value: 'Roofing Expert' },
    { id: '606', value: 'Roofing/Siding Services' },
    { id: '748', value: 'Temporary Housing' },
    { id: '676', value: 'Train' },
    { id: '746', value: 'Vehicle Systems' },
    { id: '764', value: 'Water Leak Detection Experts' }
  ],
  '105': [ // Green Experts
    { id: '', value: '' },
    { id: '749', value: 'Green Expert-Alternative Energy' },
    { id: '750', value: 'Green Expert-Architects' },
    { id: '751', value: 'Green Expert-Construction Estimating' },
    { id: '752', value: 'Green Expert-Day Lighting' },
    { id: '753', value: 'Green Expert-Electrical' },
    { id: '754', value: 'Green Expert-Engineering' },
    { id: '755', value: 'Green Expert-Flooring' },
    { id: '756', value: 'Green Expert-HVAC' },
    { id: '757', value: 'Green Expert-Insulation' },
    { id: '758', value: 'Green Expert-Plumbing' },
    { id: '759', value: 'Green Expert-Roofing' },
    { id: '760', value: 'Green Expert-Waste Water/Recycling' },
    { id: '761', value: 'Green Expert-Windows & Doors' },
    { id: '763', value: 'Lab Services - Asbestos' }
  ],
  '106': [ // Property - Adjusters/Evaluations
    { id: '', value: '' },
    { id: '732', value: 'Accounting' },
    { id: '762', value: 'Arborists/Tree Evaluations' },
    { id: '747', value: 'Construction Consultants' },
    { id: '620', value: 'Engineering Evaluations' },
    { id: '621', value: 'Fine Arts Appraisals' },
    { id: '677', value: 'Marine Surveyors' },
    { id: '662', value: 'Property Adjuster - Commercial' },
    { id: '660', value: 'Property Adjuster - General' },
    { id: '664', value: 'Property Adjuster - Residential' }
  ],
  '107': [ // Property - All Damages
    { id: '', value: '' },
    { id: '762', value: 'Arborists/Tree Evaluations' },
    { id: '602', value: 'BOARD UP Services' },
    { id: '747', value: 'Construction Consultants' },
    { id: '683', value: 'Contents Pack-out Services' },
    { id: '615', value: 'Contents Replacement Services' },
    { id: '765', value: 'Cyber Security Forensics' },
    { id: '678', value: 'Demolition Services' },
    { id: '613', value: 'Dry Cleaning Svcs' },
    { id: '745', value: 'Elevators/Escalators' },
    { id: '610', value: 'Emergency Svcs/General' },
    { id: '680', value: 'Furrier' },
    { id: '601', value: 'Glass Replacement' },
    { id: '681', value: 'Jeweler' },
    { id: '687', value: 'Mitigation Dispatch' },
    { id: '617', value: 'Salvage Services' },
    { id: '686', value: 'Textile Restoration' }
  ],
  '108': [ // Property- Cleanup/Replacement
    { id: '', value: '' },
    { id: '602', value: 'BOARD UP Services' },
    { id: '683', value: 'Contents Pack-out Services' },
    { id: '679', value: 'Crime Scene/Death Clean-up' },
    { id: '610', value: 'Emergency Svcs/General' },
    { id: '680', value: 'Furrier' },
    { id: '601', value: 'Glass Replacement' },
    { id: '681', value: 'Jeweler' },
    { id: '687', value: 'Mitigation Dispatch' },
    { id: '617', value: 'Salvage Services' },
    { id: '614', value: 'Tree Removal' }
  ],
  '109': [ // Property- Repairs
    { id: '', value: '' },
    { id: '630', value: 'Asbestos & Lead Abatement' },
    { id: '602', value: 'BOARD UP Services' },
    { id: '603', value: 'Carpentry' },
    { id: '611', value: 'Cleaning Services' },
    { id: '747', value: 'Construction Consultants' },
    { id: '609', value: 'Drywall/Plaster' },
    { id: '605', value: 'Electrician' },
    { id: '745', value: 'Elevators/Escalators' },
    { id: '610', value: 'Emergency Svcs/General' },
    { id: '616', value: 'Fencing' },
    { id: '607', value: 'Flooring/Floor Coverings' },
    { id: '680', value: 'Furrier' },
    { id: '601', value: 'Glass Replacement' },
    { id: '688', value: 'Gutters' },
    { id: '681', value: 'Jeweler' },
    { id: '612', value: 'Masonry/Chimney' },
    { id: '608', value: 'Painting, Decorating or Wallpaper' },
    { id: '604', value: 'Plumbing' },
    { id: '600', value: 'Property - General Contractor' },
    { id: '606', value: 'Roofing/Siding Services' },
    { id: '617', value: 'Salvage Services' },
    { id: '685', value: 'Solar Services' },
    { id: '686', value: 'Textile Restoration' },
    { id: '650', value: 'Towing' }
  ],
  '110': [ // Property- Specialist
    { id: '', value: '' },
    { id: '732', value: 'Accounting' },
    { id: '762', value: 'Arborists/Tree Evaluations' },
    { id: '766', value: 'Aviation Engineer' },
    { id: '744', value: 'Boat/Yacht' },
    { id: '772', value: 'Computers/Internet' },
    { id: '747', value: 'Construction Consultants' },
    { id: '679', value: 'Crime Scene/Death Clean-up' },
    { id: '765', value: 'Cyber Security Forensics' },
    { id: '678', value: 'Demolition Services' },
    { id: '745', value: 'Elevators/Escalators' },
    { id: '620', value: 'Engineering Evaluations' },
    { id: '621', value: 'Fine Arts Appraisals' },
    { id: '680', value: 'Furrier' },
    { id: '754', value: 'Green Expert-Engineering' },
    { id: '631', value: 'HAZMAT' },
    { id: '736', value: 'Heavy Equipment' },
    { id: '727', value: 'HVAC' },
    { id: '623', value: 'Ladder Assist' },
    { id: '682', value: 'Musical Instruments' },
    { id: '622', value: 'Outside Attorneys' },
    { id: '668', value: 'Property Adjuster - Cause/Origin' },
    { id: '617', value: 'Salvage Services' },
    { id: '689', value: 'Scaffolding/shoring' },
    { id: '614', value: 'Tree Removal' },
    { id: '764', value: 'Water Leak Detection Experts' },
    { id: '770', value: 'Weather' }
  ]
};

export const CONTRACT_TYPE_OPTIONS = [
  { id: '', value: '' },
  { id: 'SF', value: 'Short form' },
  { id: 'PR', value: 'Procurement form' }
];

// Mapping of contract vendor types to their available specialities
export const CONTRACT_VENDOR_SPECIALITY_MAP: Record<string, Array<{ id: string; value: string }>> = {
  '101': [
    { id: '', value: '' },
    { id: '800', value: 'Accountant' }
  ],
  '102': [
    { id: '', value: '' },
    { id: '500', value: 'Diagnostic Testing Referrals' },
    { id: '501', value: 'DME' },
    { id: '502', value: 'Transportation' },
    { id: '503', value: 'Translation' },
    { id: '504', value: 'Home Care' }
  ],
  '103': [
    { id: '', value: '' },
    { id: '801', value: 'Asset Checking' },
    { id: '802', value: 'Skip Trace' }
  ],
  '104': [
    { id: '', value: '' },
    { id: '100', value: 'Subrogation Demand Review' }
  ],
  '105': [
    { id: '', value: '' },
    { id: '102', value: 'Appraiser Software' },
    { id: '101', value: 'Cost Calculator for Engine Damage' },
    { id: '103', value: 'Bodily Injury Disputes' }
  ],
  '106': [
    { id: '', value: '' },
    { id: '104', value: 'Expert testimony' },
    { id: '137', value: 'Accident Reconstruction' },
    { id: '105', value: 'HE Vehicle Valuation' },
    { id: '106', value: 'Speciality Vehicle Valuation' }
  ],
  '107': [
    { id: '', value: '' },
    { id: '110', value: 'Consultation' },
    { id: '107', value: 'Independent Medical Evaluations' }
  ],
  '108': [
    { id: '', value: '' },
    { id: '108', value: 'Medical Review' },
    { id: '109', value: 'Causation' },
    { id: '112', value: 'Investigative' },
    { id: '111', value: 'Police Reports' }
  ],
  '109': [
    { id: '', value: '' },
    { id: '113', value: 'Estimate Review' },
    { id: '114', value: 'Independent Appraisal' }
  ],
  '110': [
    { id: '', value: '' },
    { id: '115', value: 'Auto Estimation' },
    { id: '116', value: 'California Reinspections' }
  ],
  '111': [
    { id: '', value: '' },
    { id: '117', value: 'Parts Search' }
  ],
  '112': [
    { id: '', value: '' },
    { id: '118', value: 'Estimate Review' }
  ],
  '113': [
    { id: '', value: '' },
    { id: '119', value: 'Parts Provider' },
    { id: '120', value: 'Software' },
    { id: '121', value: 'Used Parts' },
    { id: '122', value: 'Rental Canada' },
    { id: '124', value: 'Auto Repair' }
  ],
  '114': [
    { id: '', value: '' },
    { id: '123', value: 'Paintless Dent Repair' }
  ],
  '115': [
    { id: '', value: '' },
    { id: '125', value: 'Vehicle Salvage' },
    { id: '126', value: 'Auto Parts Locator' }
  ],
  '116': [
    { id: '', value: '' },
    { id: '127', value: 'Scene Photos' },
    { id: '128', value: 'Investigative' }
  ],
  '117': [
    { id: '', value: '' },
    { id: '129', value: 'Light Sequencing' },
    { id: '130', value: 'Canadian Towing' },
    { id: '131', value: 'Accident Scene Towing' }
  ],
  '118': [
    { id: '', value: '' },
    { id: '505', value: 'Catastrophic Case Management' },
    { id: '506', value: 'Medical Case Management' }
  ],
  '119': [
    { id: '', value: '' },
    { id: '803', value: 'Claim Legal LPO Work' },
    { id: '804', value: 'Claim Services' }
  ],
  '120': [
    { id: '', value: '' },
    { id: '805', value: 'Collection Services' }
  ],
  '121': [
    { id: '', value: '' },
    { id: '806', value: 'Construction Consultants' }
  ],
  '122': [
    { id: '', value: '' },
    { id: '807', value: 'Contents Replacement Services' }
  ],
  '123': [
    { id: '', value: '' },
    { id: '808', value: 'Courier Services' }
  ],
  '124': [
    { id: '', value: '' },
    { id: '809', value: 'Credit Services' }
  ],
  '125': [
    { id: '', value: '' },
    { id: '507', value: 'Medical Bill Review' }
  ],
  '126': [
    { id: '', value: '' },
    { id: '508', value: 'Decision Point' }
  ],
  '127': [
    { id: '', value: '' },
    { id: '509', value: 'Dental Claim Consultants' },
    { id: '510', value: 'Diagnostic Testing Referrals' }
  ],
  '128': [
    { id: '', value: '' },
    { id: '512', value: 'Medical Case Management' }
  ],
  '129': [
    { id: '', value: '' },
    { id: '513', value: 'Vocational Rehabilitation' }
  ],
  '130': [
    { id: '', value: '' },
    { id: '514', value: 'Medical Treatment Protocols' },
    { id: '515', value: 'Coders' },
    { id: '516', value: 'Nurse Case Management' },
    { id: '511', value: 'Disability Management' },
    { id: '517', value: 'Drug Screening Services' },
    { id: '810', value: 'Emergency Services - CAT' }
  ],
  '131': [
    { id: '', value: '' },
    { id: '811', value: 'Engineering (All)' }
  ],
  '132': [
    { id: '', value: '' },
    { id: '812', value: 'Engineering Expert' }
  ],
  '133': [
    { id: '', value: '' },
    { id: '813', value: 'Civil Engineer' },
    { id: '875', value: 'Automotive Engineer' },
    { id: '876', value: 'Forensic Engineer' },
    { id: '814', value: 'Financial Services' },
    { id: '815', value: 'Fire Cause and Origin' }
  ],
  '134': [
    { id: '', value: '' },
    { id: '816', value: 'Fuel Services' }
  ],
  '135': [
    { id: '', value: '' },
    { id: '817', value: 'GPS services' }
  ],
  '136': [
    { id: '', value: '' },
    { id: '818', value: 'Appraisal Services' }
  ],
  '137': [
    { id: '', value: '' },
    { id: '518', value: 'Home Health Care' },
    { id: '519', value: 'DME' }
  ],
  '138': [
    { id: '', value: '' },
    { id: '520', value: 'Home Modifications' },
    { id: '521', value: 'Hospital Payment Audit Service' }
  ],
  '139': [
    { id: '', value: '' },
    { id: '819', value: 'Independent Adjuster' }
  ],
  '140': [
    { id: '', value: '' },
    { id: '523', value: 'Peer Review' }
  ],
  '141': [
    { id: '', value: '' },
    { id: '522', value: 'Independent Medical Evaluations' }
  ],
  '142': [
    { id: '', value: '' },
    { id: '524', value: 'Record Review' },
    { id: '525', value: 'Pharmacy Reviews' },
    { id: '526', value: 'Diagnostic Testing Referrals' },
    { id: '527', value: 'Records Review' },
    { id: '824', value: 'Witness Location' },
    { id: '825', value: 'Private Investigation' }
  ],
  '143': [
    { id: '', value: '' },
    { id: '826', value: 'Trial Monitoring' },
    { id: '827', value: 'Investigative Services' },
    { id: '828', value: 'Software' },
    { id: '823', value: 'Surveillance' },
    { id: '822', value: 'Summons Service' },
    { id: '820', value: 'Process Service' },
    { id: '821', value: 'Subpoena Service' },
    { id: '829', value: 'Ladder Assist' },
    { id: '830', value: 'Lawyers' }
  ],
  '144': [
    { id: '', value: '' },
    { id: '831', value: 'Legal Solutions' }
  ],
  '145': [
    { id: '', value: '' },
    { id: '832', value: 'Legal Aid' },
    { id: '833', value: 'Court Reporting' },
    { id: '835', value: 'Videographer' }
  ],
  '146': [
    { id: '', value: '' },
    { id: '837', value: 'Records Retrieval' },
    { id: '838', value: 'Subpoena Preparation' },
    { id: '839', value: 'X-ray Copying and Scanning' },
    { id: '840', value: 'Medical Record Analysis' },
    { id: '841', value: 'Statistical Analysis' },
    { id: '842', value: 'Medical Provider Fraud' },
    { id: '836', value: 'Video Conferencing' },
    { id: '834', value: 'Stenographer' },
    { id: '872', value: 'Medical Expert' },
    { id: '874', value: 'Security Consultant' },
    { id: '877', value: 'Interpreting' },
    { id: '873', value: 'Human Factors Expert' },
    { id: '843', value: 'Claim University' }
  ],
  '147': [
    { id: '', value: '' },
    { id: '528', value: 'Disability Management' }
  ],
  '148': [
    { id: '', value: '' },
    { id: '529', value: 'PPO Network' }
  ],
  '149': [
    { id: '', value: '' },
    { id: '530', value: 'Independent Medical Evaluations' },
    { id: '844', value: 'Marine Surveyors' },
    { id: '531', value: 'Medical Assistance' }
  ],
  '150': [
    { id: '', value: '' },
    { id: '532', value: 'Medical Cost Management' }
  ],
  '151': [
    { id: '', value: '' },
    { id: '534', value: 'Medical Bill Review' },
    { id: '535', value: 'Medical Canvassing' }
  ],
  '152': [
    { id: '', value: '' },
    { id: '536', value: 'Medical Case Management' }
  ],
  '153': [
    { id: '', value: '' },
    { id: '537', value: 'Medical Treatment Protocols' }
  ],
  '154': [
    { id: '', value: '' },
    { id: '533', value: 'Medical Treatment Protocols' }
  ],
  '155': [
    { id: '', value: '' },
    { id: '538', value: 'Medicare Set Aside' },
    { id: '539', value: 'Network Provider Selection' }
  ],
  '156': [
    { id: '', value: '' },
    { id: '847', value: 'Hiring' }
  ],
  '157': [
    { id: '', value: '' },
    { id: '845', value: 'Typing Speed and Accuracy' }
  ],
  '158': [
    { id: '', value: '' },
    { id: '846', value: 'Testing' },
    { id: '848', value: 'Offshore Sourcing' },
    { id: '540', value: 'Independent Medical Evaluations' }
  ],
  '159': [
    { id: '', value: '' },
    { id: '541', value: 'Peer Review' }
  ],
  '160': [
    { id: '', value: '' },
    { id: '542', value: 'Pharmacy Reviews' },
    { id: '543', value: 'Record Review' },
    { id: '544', value: 'Pharmacy Management' },
    { id: '545', value: 'Ancillary Management' }
  ],
  '161': [
    { id: '', value: '' },
    { id: '546', value: 'DME' },
    { id: '547', value: 'Medical Case Management' },
    { id: '548', value: 'Physician Consultation' }
  ],
  '162': [
    { id: '', value: '' },
    { id: '549', value: 'Physician Provider Reviews' },
    { id: '849', value: 'Plumbing/Leak Detection' }
  ],
  '163': [
    { id: '', value: '' },
    { id: '850', value: 'Property Estimation' }
  ],
  '164': [
    { id: '', value: '' },
    { id: '851', value: 'Salvage Services' }
  ],
  '165': [
    { id: '', value: '' },
    { id: '852', value: 'Vehicle Salvage' }
  ],
  '166': [
    { id: '', value: '' },
    { id: '853', value: 'Heavy Equipment Salvage' },
    { id: '854', value: 'Scanning and Data Capture Services' },
    { id: '858', value: 'E-billing Services' }
  ],
  '167': [
    { id: '', value: '' },
    { id: '860', value: 'Document Comparison Software' }
  ],
  '168': [
    { id: '', value: '' },
    { id: '855', value: 'Legal Software' },
    { id: '856', value: 'LegalPrecision' },
    { id: '857', value: 'CounselLink' },
    { id: '859', value: 'Workshare Professional' },
    { id: '861', value: 'Collaborative Authoring Software' },
    { id: '862', value: 'Software' },
    { id: '863', value: 'Case Management Software' },
    { id: '864', value: 'Disability Management' }
  ],
  '169': [
    { id: '', value: '' },
    { id: '865', value: 'Subrogation Services' },
    { id: '866', value: 'Subrogation Claim Administration' },
    { id: '867', value: 'Temporary Housing' }
  ],
  '170': [
    { id: '', value: '' },
    { id: '868', value: 'Testing/Analysis' }
  ],
  '171': [
    { id: '', value: '' },
    { id: '132', value: 'Towing' }
  ],
  '172': [
    { id: '', value: '' },
    { id: '133', value: 'Accident Scene Towing' },
    { id: '869', value: 'TPA' }
  ],
  '173': [
    { id: '', value: '' },
    { id: '870', value: 'Training' }
  ],
  '174': [
    { id: '', value: '' },
    { id: '550', value: 'Physician Provider Reviews' }
  ],
  '175': [
    { id: '', value: '' },
    { id: '551', value: 'Utilization Review' },
    { id: '552', value: 'Medical case management' }
  ],
  '176': [
    { id: '', value: '' },
    { id: '134', value: 'Vehicle Rental Services' }
  ],
  '177': [
    { id: '', value: '' },
    { id: '135', value: 'Vehicle Valuation' }
  ],
  '178': [
    { id: '', value: '' },
    { id: '136', value: 'Appraiser Resource' },
    { id: '553', value: 'Vocational Placement' }
  ],
  '179': [
    { id: '', value: '' },
    { id: '554', value: 'Work at Home' },
    { id: '871', value: 'Weather Data' }
  ],
  '180': [
    { id: '', value: '' },
    { id: '560', value: 'Physician Provider Reviews' }
  ],
  '181': [
    { id: '', value: '' },
    { id: '558', value: 'Prescription Drug Program' },
    { id: '559', value: 'WC Concierge Program' },
    { id: '555', value: 'Independent Medical Evaluations' },
    { id: '556', value: 'Medical Case Management' },
    { id: '557', value: 'Disability Management' }
  ]
};

// Grouped contract vendor specialities - organized by contract vendor type with descriptive group names




export const VENDOR_TYPE_CODE_OPTIONS = [
  { id: '11', value: '11 - Auto - Auto Body Repair' },
  { id: '60', value: '60 - Property' },

];

export const SEARCH_MILES_OPTIONS = [
  { id: '15', value: '15' },
  { id: '25', value: '25' },
  { id: '50', value: '50' },
  { id: '100', value: '100' },
];


// Admin - includes all options
export const ADMIN_APPROVAL_STATUS_OPTIONS = [
  { id: '', value: '' },
  { id: 'APPROVED', value: 'Approved Vendors' },
  { id: 'CONTRACT', value: 'Contract Vendor' },
  { id: 'LAB_INLAND', value: 'Lab Vendor and Inland Mar' },
  { id: 'MCU_APPROVED', value: 'MCU Approved' }
];




export const APPRAISAL_SOFTWARE_KEY_OPTIONS = [
  { id: 'MTCH', value: 'AS-MITCHELL-001' },
  { id: 'CCC', value: 'CCCONE' },
  { id: 'AUDX', value: 'AUDX-001' },
]